import classList from "flarum/utils/classList";
import Component from "flarum/Component";
import extractText from 'flarum/utils/extractText';
import icon from "flarum/helpers/icon";
import KeyboardNavigatable from "flarum/utils/KeyboardNavigatable";
import withAttr from 'flarum/utils/withAttr';

export default class CustomDiscussionSearch extends Component {

  oninit(vnode) {
    super.oninit(vnode);

    this.state = this.attrs.state;
    this.tag = app.store.getBy('tags', 'slug', this.attrs.slug);
    this.hasFocus = false;
    app.discussions.searchValue("");
  }

  view(vnode) {
    // If no tag is selected (fx. during global search), don't show the search
    // box.
    if (this.tag == null) {
      return <div/>;
    }

    return (
      <div
        className={
          `Search ${
            classList({
              open: app.discussions.searchValue() && this.hasFocus,
              loading: app.discussions.searchValue() && app.discussions.loading,
            })}`
        }
      >
        <div className="Search-input">
          <input
            className="FormControl Tag-search"
            type="search"
            placeholder={extractText(
              app.translator.trans('core.forum.index_page.search_placeholder',
                {tag: this.tag.name()})
            )}
            value={app.discussions.searchValue()}
            oninput={withAttr('value', app.discussions.searchValue)}
            onfocus={() => (this.hasFocus = true)}
            onblur={() => (this.hasFocus = false)}
          />
          {app.discussions.searchValue() ? (
            <button className="Search-clear Button Button--icon Button--link"
                    onclick={this.clear.bind(this)}>
              {icon('fas fa-times-circle')}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    const $input = this.$('input.Tag-search');

    this.navigator = new KeyboardNavigatable();
    this.navigator
      .onSelect(this.search.bind(this))
      .onCancel(this.clear.bind(this))
      .bindTo($input);
  }

  /**
   * Update the discussion list if search is not empty.
   */
  search() {
    this.$('input.Tag-search').blur();
    if (app.discussions.searchValue()) {
      app.discussions.getParams().q = ` ${app.discussions.searchValue()}`;
      app.discussions.refresh();
    } else {
      this.clear();
    }
  }


  /**
   * Reset discussion list when clicking cancel button, searching for empty
   * string, or pressing escape.
   */
  clear() {
    app.discussions.searchValue("");
    app.discussions.getParams().q = "";
    app.discussions.refresh({deferClear: true});
  }

}
